export const ALERT_FIELD_RULES = {
  systemVoltage: {
    allowedTypes: ["one-bound", "two-bound", "fault-code"],
    defaultType: "one-bound",
    label: "System Voltage",
    allowDelete: true,
  },
  hydraulicPressure: {
    allowedTypes: ["one-bound", "two-bound", "fault-code"],
    defaultType: "one-bound",
    label: "Hydraulic Pressure",
    valveGroup: true,
    allowDelete: true,
  },
  pressureRange: {
    allowedTypes: ["two-bound"],
    defaultType: "two-bound",
    label: "Pressure Range",
    valveGroup: true,
    allowDelete: true,
  },
  checkState: {
    allowedTypes: ["fault-code"],
    defaultType: "fault-code",
    label: "Check State",
    valveGroup: true,
    allowDelete: false,
  },
  communicationFault: {
    allowedTypes: ["fault-code"],
    defaultType: "fault-code",
    label: "Communication Fault",
    valveGroup: true,
    allowDelete: false,
  },
  bleedState: {
    allowedTypes: ["fault-code"],
    defaultType: "fault-code",
    label: "Bleed State",
    valveGroup: true,
    allowDelete: false,
  },
  transducerFaults: {
    allowedTypes: ["fault-code"],
    defaultType: "fault-code",
    label: "Transducer Faults",
    transducerGroup: true,
    allowDelete: false,
  },
};
